export class Parametro {
  categoria: string;
  clase: string;
  f_alta: string;
  flag: boolean;
  valor: string;
  modulo: string;
}
